import styled from 'styled-components';
import * as S from '../../SecondaryNav/Styled';
import { Link } from 'react-router-dom';
import cn from 'classnames';

export const Overlay = styled.div`
  background: rgba(50, 61, 76, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  opacity: 0;
  display: none;
  transition: var(--transition);

  @media (min-width: 768px) {
    display: none !important;
  }
`;

export const ProfileNav = styled.div.attrs(({ visible }) => ({
  className: cn({
    'is-visible': visible,
  }),
}))`
  --panel-w: min(300px, calc(100 * var(--full-vw, 1vw) - 44px));
  width: var(--panel-w);
  height: calc(100 * var(--full-vh, 1vh));
  right: 0;
  top: 0;
  position: fixed;
  background: var(--aluminium10);
  z-index: 1002;
  padding: 12px;
  transform: translateX(var(--panel-w));
  transition: var(--transition);

  &.is-visible {
    transform: translateX(0);

    + ${Overlay} {
      opacity: 1;
      display: block;
    }
  }

  ${S.List} {
    margin: 0 20px;
  }

  .icon_cart {
    top: -2px;
  }

  @media (min-width: 768px) {
    display: none !important;
  }
`;

export const MainWrap = styled.div`
  position: absolute;
  top: 64px;
  bottom: 52px;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const User = styled.div`
  padding: 20px 20px 10px 20px;
`;

export const Name = styled.div`
  font-size: 17px;
  line-height: 1.18em;
  color: var(--carbone100);
  margin-bottom: 0.4em;
  font-weight: 600;
`;

export const Email = styled.div`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.54em;
  color: var(--carbone70);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const StyledLink = styled(Link)`
  padding: 0 20px;
  background: var(--white);
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  letter-spacing: -0.03em;
  box-shadow: 0 -1px var(--aluminium35), 0 1px var(--aluminium35);
  color: var(--carbone100);

  .icon_user,
  .icon_mail {
    fill: none;
    stroke: var(--carbone100);
    stroke-width: 1.7;
  }

  &:hover {
    color: var(--theme-palette-brand-color);

    .icon_user,
    .icon_mail {
      stroke: var(--theme-palette-brand-color);
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--aluminium35);
`;

export const CloseBtn = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--white);
  padding: 0;
  position: absolute;
  right: 12px;
  top: 12px;
  opacity: 0.6;
  cursor: pointer;
  border: 1px solid var(--grey20);
  border-radius: 50%;
  color: var(--carbone70);
  transition: var(--transition);

  .icon_close {
    left: -0.5px;
    top: -0.5px;
    font-size: 10px;
  }

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }
`;

export const Menu = styled.div`
  padding: 10px 0;
  list-style: none;

  ${StyledLink} {
    font-size: 15px;
  }
`;

export const IconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 22px;
`;

export const Label = styled.span``;

export const SecondaryNav = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-shadow: 0 -1px var(--aluminium35);
`;

export const Logout = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5em;
  color: var(--red100);
  align-items: center;
  display: flex;
  justify-content: center;
  height: 52px;

  &:hover {
    color: var(--red120);
  }
`;
